export enum ModalName {
  UnavailableRestaurant = 'unavailableRestaurant',
  UnavailableStore = 'unavailableStore',
  UnavailableDelivery = 'unavailableDelivery',
  UnavailablePickup = 'unavailablePickup',
  OutOfDeliveryAreaNoPickup = 'outOfDeliveryAreaNoPickup',
  OutOfDeliveryAreaWithPickup = 'outOfDeliveryAreaWithPickup',
  NoAddress = 'noAddress',
}

export type ButtonConfig = {
  label: string;
  onClick: () => void;
};

export type PieGeneralModalArgs = {
  imgSrc: string;
  imgAlt?: string;
  header: string;
  subHeader: string;
  primaryButton: ButtonConfig;
  secondaryButton?: ButtonConfig;
  onMount?: () => void;
  onClose?: () => void;
};
